import { Box, Typography } from "@mui/joy";
import type { ProductWithPrice } from "../types";

interface OrderTotalProps {
    items: ProductWithPrice[];
}

export function OrderTotal({ items }: OrderTotalProps) {
    const total = items.reduce((sum, item) => sum + (item.Total || 0), 0);
    const hasItemsWithoutPrice = items.some(
        (item) => !item.UnitPrice || item.UnitPrice === 0,
    );

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="baseline"
            gap={1.5}
            mt={1}
            pt={1}
        >
            <Typography level="body-sm" sx={{ fontWeight: 700 }}>
                Total
            </Typography>
            <Box textAlign="right">
                <Typography level="title-md" sx={{ fontWeight: 600 }}>
                    $
                    {total.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                </Typography>
                {hasItemsWithoutPrice && (
                    <Typography level="body-xs" sx={{ color: "text.secondary" }}>
                        * Some items have no price
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
